import { css, cx } from '@eti/styles';
import { SlidersHorizontal } from '@phosphor-icons/react';
import { useTranslation, useProperty } from '@eti/providers';
import { Button } from '@etg/wings';

const controlButtonStyles = css`
  width: 100%;
`;

const desktopFiltersButton = css`
  justify-content: center;
`;

interface ResultFiltersToggleButtonProps {
  onClick: () => void;
  isOpen: boolean;
}

const ResultFiltersToggleButton = ({ onClick, isOpen }: ResultFiltersToggleButtonProps) => {
  const { p } = useProperty();
  const { t } = useTranslation();
  return (
    <Button
      className={cx(
        controlButtonStyles,
        p('Result.Page.V3.DesktopDrawerSearchResultFilters.Enabled') && desktopFiltersButton,
      )}
      data-testid="resultPage-toggleFiltersButton-button"
      iconPrefix={<SlidersHorizontal aria-hidden id={isOpen ? 'close-icon' : 'sliders-icon'} />}
      onClick={onClick}
      size="small"
      type="button"
    >
      {t('Result.Filters.Toggle.Button.Label')}
    </Button>
  );
};

export default ResultFiltersToggleButton;
